import { createApp } from "vue"
import { createPinia } from "pinia"
import App from "@/common/App.vue"
import router from "@/apps/recruiter/router/router"
import { Quasar } from "quasar"
import quasarLang from "quasar/lang/ru"
import Vue3Toasity, { ToastContainerOptions } from "vue3-toastify"

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Quasar, {
    config: {
        dark: true,
        brand: {
            primary: "#1890ff",
            secondary: "#424242",
            accent: "#9C27B0",

            dark: "#28282B",
            "dark-page": "#202021",

            positive: "#21BA45",
            negative: "#C10015",
            info: "#31CCEC",
            warning: "#F2C037"
        }
    },
    plugins: {},
    lang: quasarLang
})
app.use(Vue3Toasity, {
    autoClose: 3000,
    position: "top-center",
    closeButton: true
} as ToastContainerOptions)

app.mount("#app")
